module.exports = __webpack_public_path__ + "static/bg-54fc4cf5dfcee34d66d662c13fb5d69c.jpg";